export default __webpack_public_path__ + "static/media/sorteo-header-pc.ae3ed4fb.png";